/* src/app/common/mpos-entity/components/di-view-header/di-view-header.component.scss */
:host {
  display: flex;
  flex: 1 0 0%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 12px;
  flex-wrap: nowrap;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9jb21tb24vbXBvcy1lbnRpdHkvY29tcG9uZW50cy9kaS12aWV3LWhlYWRlci9kaS12aWV3LWhlYWRlci5jb21wb25lbnQuc2NzcyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiOmhvc3Qge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleDogMSAwIDAlO1xuXG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBhbGlnbi1jb250ZW50OiBjZW50ZXI7XG5cblxuICAgIC8vIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZTRlOWYwO1xuICAgIHBhZGRpbmc6IDEycHg7XG4gICAgZmxleC13cmFwOiBub3dyYXA7XG59XG4iXSwKICAibWFwcGluZ3MiOiAiO0FBQUE7QUFDSSxXQUFBO0FBQ0EsUUFBQSxFQUFBLEVBQUE7QUFFQSxrQkFBQTtBQUNBLG1CQUFBO0FBQ0EsZUFBQTtBQUNBLGlCQUFBO0FBSUEsV0FBQTtBQUNBLGFBQUE7OyIsCiAgIm5hbWVzIjogW10KfQo= */
